// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38fcb961","732":"5e1a5c17","977":"8db05e48"}[chunkId] + ".chunk.js";
};